export default __webpack_public_path__ + "static/media/DinosaursFlyingRetiples_08.977fc929.png";